import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const PercentageIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      d="m18.414 7.414-11 11L6 17 17 6zM15.5 15a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-6-9a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
    />
  </BaseIcon>
)
